/** Lightweight auth / profile loading placeholder (replaces blank screen). */

export function AuthLoading() {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 px-4">
      <div
        className="h-8 w-8 animate-pulse rounded-full bg-brand/25"
        aria-hidden
      />
      <p className="text-sm text-muted-foreground">Ładowanie…</p>
    </div>
  );
}
